import React from 'react';
import {object, func, bool} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import ErrorDisplay from 'components/common/ErrorDisplay';
import {basicForm} from 'utils/helpers';
import config from './copyPrizeFormConfig';

const CopyPrizeForm = basicForm(config);

const CopyPrizeModal = props => (
  <BasicModal
    header='Copy a prize'
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: 'Cancel',
        action: props.handleClose,
        isDisabled: false,
        displayType: 'menu-item'
      },
      {
        label: 'Copy prize',
        action: props.submit,
        isDisabled: props.hasErrors || !props.formData.title,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <CopyPrizeForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
  </BasicModal>
);

CopyPrizeModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,

  handleClose: func.isRequired,
  modalOpen: bool.isRequired
};

export default CopyPrizeModal;



// WEBPACK FOOTER //
// ./public/components/prizes/CopyPrizeModal.jsx